import React, { useContext, useState } from "react";
import cx from "classnames";

import GameContext from "../../Context";
import { Ray, Direction } from "../../../../types/GameTypes";
import { FetchResult } from "../../../../services/GameService";
import Spinner from "../../../UI/Spinner";

import "./Port.scss";

import portUnused from "./port.gif";
import portHit from "./port-hit.gif";
import portReflection from "./port-reflection.gif";
import portDetour0 from "./port-detour-0.gif";
import portDetour1 from "./port-detour-1.gif";
import portDetour2 from "./port-detour-2.gif";
import portDetour3 from "./port-detour-3.gif";
import portDetour4 from "./port-detour-4.gif";
import portDetour5 from "./port-detour-5.gif";
import portDetour6 from "./port-detour-6.gif";
import portDetour7 from "./port-detour-7.gif";
import portDetour8 from "./port-detour-8.gif";
import portDetour9 from "./port-detour-9.gif";
import portDetour10 from "./port-detour-10.gif";

type Props = {
  ordinal: number;
  direction: Direction;
};

const detourImages = [
  portDetour0,
  portDetour1,
  portDetour2,
  portDetour3,
  portDetour4,
  portDetour5,
  portDetour6,
  portDetour7,
  portDetour8,
  portDetour9,
  portDetour10,
];

function portForRay(ray: Ray | undefined) {
  if (!ray) return portUnused;
  return ray.result === "HIT"
    ? portHit
    : ray.result === "REFLECTION"
    ? portReflection
    : detourImages[ray.detourOrdinal];
}

function GameBoardPort({ ordinal, direction }: Props) {
  const { engine } = useContext(GameContext);

  const [rayResult, setRayApiResult] = useState<FetchResult<Ray>>({ loading: false });

  const styles = makeGridStyles(ordinal, direction);

  const ray = engine.getRayFor(ordinal);

  const handleClick = async () => {
    if (engine.isRunning()) {
      if (!ray) {
        engine.shootRayInto(ordinal, setRayApiResult);
      }
    } else {
      if (ray) {
        engine.showPathFor(ordinal);
      }
    }
  };

  const loading = rayResult.loading;

  return (
    <div className={cx("port", `port-${ordinal}`, ray ? "used" : "")} style={styles} onClick={handleClick}>
      <img src={portForRay(ray)} alt="port" />
      {loading && <Spinner />}
    </div>
  );
}

function makeGridStyles(ordinal: number, direction: Direction) {
  switch (direction) {
    case "SOUTH":
      return { gridColumnStart: ordinal + 1, gridColumnEnd: ordinal + 2, gridRowStart: 1, gridRowEnd: 2 };
    case "WEST":
      return { gridColumnStart: 10, gridColumnEnd: 11, gridRowStart: ordinal - 7, gridRowEnd: ordinal - 6 };
    case "NORTH":
      return { gridColumnStart: 26 - ordinal, gridColumnEnd: 27 - ordinal, gridRowStart: 10, gridRowEnd: 11 };
    case "EAST":
      return { gridColumnStart: 1, gridColumnEnd: 2, gridRowStart: 35 - ordinal, gridRowEnd: 34 - ordinal };
    default:
  }
}

export default GameBoardPort;
